var bubbleSvgs = [
    `
    <svg width="456" height="492" viewBox="0 0 456 492" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M176.973 142.974C170.646 287.421 -44.5648 284.342 8.94902 416.955C61.9007 550.866 292.44 481.212 402.191 386.198C511.941 291.183 428.712 159.567 362.267 56.7995C295.822 -45.9676 183.3 -1.47346 176.973 142.974Z" fill="url(#paint0_linear_547_1370)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1370" x1="283.968" y1="458.076" x2="124.773" y2="55.4851" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="540" height="488" viewBox="0 0 540 488" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M364.207 11.0558C180.144 71.9743 391.668 134.085 224.707 248.056C56.0745 362.08 -75.2032 408.735 49.4688 471.975C174.141 535.216 338.821 392.633 467.355 279.876C595.888 167.12 548.27 -49.8627 364.207 11.0558Z" fill="url(#paint0_linear_547_1371)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1371" x1="0.445968" y1="431.109" x2="533.248" y2="70.8452" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="357" height="259" viewBox="0 0 357 259" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M334.415 150.126C397.415 82.1261 318.415 29.1261 201.415 7.12608C85.4149 -14.8739 22.8071 13.3021 1.80698 102.302C-13.0335 165.197 66.4149 240.126 136.415 256.126C206.415 272.126 271.415 218.126 334.415 150.126Z" fill="url(#paint0_linear_547_1372)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1372" x1="0.00097623" y1="129.48" x2="356.679" y2="129.48" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="719" height="395" viewBox="0 0 719 395" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M334.414 285.398C397.414 217.398 694 297.041 718.5 209.541C679 58.0407 587.9 -17.7884 431.5 3.54071C246.725 28.7394 13.1794 189.372 1.806 237.573C-13.0345 300.468 66.4139 375.397 136.414 391.397C206.414 407.397 271.414 353.398 334.414 285.398Z" fill="url(#paint0_linear_547_1375)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1375" x1="-6.69162e-07" y1="197.115" x2="718.5" y2="197.115" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="462" height="437" viewBox="0 0 462 437" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M439.492 202.692C413.937 113.586 99.9964 -63.6646 20.5944 25.0391C-58.2897 112.887 113.264 188.165 178.531 252.214C224.654 297.476 377.722 478.57 427.655 426.968C477.588 375.367 465.046 291.799 439.492 202.692Z" fill="url(#paint0_linear_547_1376)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1376" x1="174.965" y1="308.23" x2="312.35" y2="81.2349" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="436" height="372" viewBox="0 0 436 372" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M334.414 262.857C397.414 194.857 498.5 24.2311 381.5 2.23111C265.5 -19.7689 22.8062 126.033 1.806 215.033C-13.0345 277.928 66.4139 352.857 136.414 368.857C206.414 384.857 271.414 330.857 334.414 262.857Z" fill="url(#paint0_linear_547_1686)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1686" x1="-4.05402e-07" y1="185.845" x2="435.292" y2="185.845" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="719" height="395" viewBox="0 0 719 395" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M334.414 285.398C397.414 217.398 694 297.041 718.5 209.541C679 58.0407 587.9 -17.7884 431.5 3.54071C246.725 28.7394 13.1794 189.372 1.806 237.573C-13.0345 300.468 66.4139 375.397 136.414 391.397C206.414 407.397 271.414 353.398 334.414 285.398Z" fill="url(#paint0_linear_547_1687)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1687" x1="-6.69162e-07" y1="197.115" x2="718.5" y2="197.115" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
    `
    <svg width="462" height="437" viewBox="0 0 462 437" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path opacity="0.1" d="M439.492 202.692C413.937 113.586 99.9964 -63.6646 20.5944 25.0391C-58.2897 112.887 113.264 188.165 178.531 252.214C224.654 297.476 377.722 478.57 427.655 426.968C477.588 375.367 465.046 291.799 439.492 202.692Z" fill="url(#paint0_linear_547_1688)"/>
    <defs>
    <linearGradient id="paint0_linear_547_1688" x1="174.965" y1="308.23" x2="312.35" y2="81.2349" gradientUnits="userSpaceOnUse">
    <stop stop-color="#439CFB"/>
    <stop offset="1" stop-color="#F187FB"/>
    </linearGradient>
    </defs>
    </svg>
    `,
];

function createBubble () {
    const element = document.createElement ('div');

    let index;
    do {
        index = Math.round (Math.random () * (bubbleSvgs.length - 1));
    } while (index === lastBubbleIndex);

    lastBubbleIndex = index;

    element.innerHTML = bubbleSvgs [index];

    element.style.cssText = `
        position: relative;

        z-index: -1;

        mix-blend-mode: multiply;

        margin-top: 50px;
    `;

    return element;
}

function appendBubble (parent, x) {
    const element = createBubble ();

    const elementWidth = element.children [0].getBBox ().width;

    element.style.marginLeft = (x - (elementWidth / 2)) + 'px';
    
    parent.appendChild (element);
}

var lastBubbleIndex;
var bubbleBackground;
var lastHeight;
window.addEventListener('DOMContentLoaded', () => {
    const element = document.createElement ('div');
    element.style.cssText = `
        position: absolute;

        pointer-events: none;

        overflow: hidden;
        width: 100%;
    `;

    bubbleBackground = element;
    document.addEventListener ('scroll', () => {
        const height = document.body.scrollHeight;
        if (lastHeight === height) {
            return;
        }

        bubbleBackground.style.height = height + 'px';
        lastHeight = height;
    })
    document.body.appendChild (element);

    const STEP = 500;
    const MARGIN = 50;

    let parsedHeight = 0;

    const height = document.body.scrollHeight;
    lastHeight = height;

    const steps = Math.ceil (height / (STEP + MARGIN)) - 1;

    for (let i = 0; i < steps; i++) {
        const xPosition = Math.random () * document.body.clientWidth;

        appendBubble (element, xPosition);
    }

    document.body.style.overflowX = 'hidden';
});  